import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest, apiRequest2 } from "../_helpers/apiConfig";

export const getAllCommunityList = createAsyncThunk(
  "adminApi/communityList",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/adminApi/communityList",
      filters,
    );
    return response;
  },
);

export const getPostComment = createAsyncThunk(
  "community/getPostComment",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/community/getPostComment",
      filters,
    );
    return response;
  },
);

export const getCommunityDetails = createAsyncThunk(
  "community2/getCommunityDetails",
  async (arg) => {
    const response = await apiRequest(
      "POST",
      "/v1/community2/getCommunityDetails",
      arg,
    );
    return response;
  },
);

export const getCommunityUsers = createAsyncThunk(
  "community2/getCommunityUsers",
  async (arg) => {
    const response = await apiRequest(
      "POST",
      "/v1/community2/getCommunityUsers",
      arg,
    );
    return response;
  },
);

export const deletecommunityPost = createAsyncThunk(
  "community2/deletecommunityPost",
  async (arg, thunkAPI) => {
    const { Payload, isRefresh } = arg;
    const response = await apiRequest(
      "POST",
      "/v1/community2/deletecommunityPost",
      Payload,
    );
    if (response.message) {
      thunkAPI.dispatch(getCommunityDetails(isRefresh));
    }
    return response;
  },
);

export const deletecomment = createAsyncThunk(
  "community2/deletecomment",
  async (arg, thunkAPI) => {
    const { Payload, isRefresh } = arg;
    const response = await apiRequest(
      "POST",
      "/v1/community2/deletecomment",
      Payload,
    );
    if (response.message) {
      thunkAPI.dispatch(getCommunityDetails(isRefresh));
    }
    return response;
  },
);

export const actionByAdminOnCommunityUserForm = createAsyncThunk(
  "/adminApi/community/toggle-status",
  async (payload) => {
    const response = await apiRequest(
      "POST",
      "/v1/adminApi/community/toggle-status",
      payload,
    );
    return response;
  },
);

export const actionByAdminOnSessionBook = createAsyncThunk(
  "/adminApi/book/toggle-status",
  async (payload) => {
    const response = await apiRequest(
      "POST",
      "/v1/adminApi/book/toggle-status",
      payload,
    );
    return response;
  },
);

export const actionByAdminOnCourseBook = createAsyncThunk(
  "/adminApi/course/toggle-status",
  async (payload) => {
    const response = await apiRequest(
      "POST",
      "/v1/adminApi/course/toggle-status",
      payload,
    );
    return response;
  },
);

const communitySlice = createSlice({
  name: "community",
  initialState: {
    community: [],
    totalCommunity: null,
    getCommunityDetailsData: {},
    getCommunityUsersData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCommunityList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCommunityList.fulfilled, (state, action) => {
        state.loading = false;
        state.community = action?.payload?.data?.list;
        state.totalCommunity = action?.payload?.data?.total;
      })
      .addCase(getAllCommunityList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getPostComment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPostComment.fulfilled, (state, action) => {
        state.loading = false;
        state.getPostComment = action?.payload?.data?.list;
        state.totalgetPostComment = action?.payload?.data?.total;
      })
      .addCase(getPostComment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deletecommunityPost.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletecommunityPost.fulfilled, (state, action) => {
        state.loading = false;
        state.community = action?.payload;
      })
      .addCase(deletecommunityPost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(getCommunityDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCommunityDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.getCommunityDetailsData = action?.payload?.data;
      })
      .addCase(getCommunityDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(getCommunityUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCommunityUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.getCommunityUsersData = action?.payload?.data;
      })
      .addCase(getCommunityUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default communitySlice.reducer;
